(function () {
  var config = window.__GEEKO_SMILE_CONFIG__ || {};
  var initialized = false;
  var readyMarked = false;

  function markSmileUiReady() {
    if (readyMarked) return;
    readyMarked = true;
    document.body.classList.add('geeko-smile-ui-ready');
    document.dispatchEvent(new CustomEvent('geeko-smile-ui-ready'));
  }

  function runWhenSmileUiReady(fn) {
    if (typeof window.SmileUI === 'undefined') return false;
    try {
      if (window.SmileUI.ready && typeof window.SmileUI.ready.then === 'function') {
        window.SmileUI.ready().then(fn).catch(fn);
      } else {
        fn();
      }
      return true;
    } catch (e) {
      return false;
    }
  }

  function initializeSmileUi(customerToken) {
    if (initialized) {
      runWhenSmileUiReady(markSmileUiReady);
      return true;
    }
    if (typeof window.SmileUI === 'undefined' || typeof window.SmileUI.initialize !== 'function') {
      return false;
    }
    if (!config.publishableKey) return false;

    var opts = { publishableKey: config.publishableKey };
    if (customerToken) {
      opts.customerToken = customerToken;
    }

    try {
      window.SmileUI.initialize(opts);
      initialized = true;
      runWhenSmileUiReady(markSmileUiReady);
      return true;
    } catch (e) {
      console.warn('[geeko-smile] SmileUI.initialize failed', e);
      return false;
    }
  }

  function resolveCustomerTokenThenInit() {
    if (config.mode !== 'manual') {
      waitForAppSmileUi();
      return;
    }

    if (!config.shopifyCustomerId || !config.customerTokenUrl) {
      initializeSmileUi(null);
      return;
    }

    var url =
      config.customerTokenUrl +
      (config.customerTokenUrl.indexOf('?') >= 0 ? '&' : '?') +
      'customer_id=' +
      encodeURIComponent(String(config.shopifyCustomerId));

    fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('token fetch failed');
        return res.json();
      })
      .then(function (data) {
        var token = data && (data.customerToken || data.customer_token || data.token);
        initializeSmileUi(token || null);
      })
      .catch(function () {
        initializeSmileUi(null);
      });
  }

  function onSmileUiLoaded() {
    if (config.mode === 'manual') {
      resolveCustomerTokenThenInit();
      return;
    }
    waitForAppSmileUi();
  }

  function waitForAppSmileUi() {
    if (
      typeof window.SmileUI !== 'undefined' &&
      typeof window.SmileUI.openPanel === 'function'
    ) {
      runWhenSmileUiReady(markSmileUiReady);
      return;
    }

    var n = 0;
    var id = setInterval(function () {
      if (
        typeof window.SmileUI !== 'undefined' &&
        typeof window.SmileUI.openPanel === 'function'
      ) {
        clearInterval(id);
        runWhenSmileUiReady(markSmileUiReady);
      } else if (++n > 150) {
        clearInterval(id);
      }
    }, 100);
  }

  document.addEventListener('smile-ui-loaded', onSmileUiLoaded, { once: true });

  if (config.mode === 'shopify-app') {
    document.addEventListener(
      'smile-shopify-loaded',
      function () {
        setTimeout(waitForAppSmileUi, 300);
      },
      { once: true }
    );
    waitForAppSmileUi();
  } else if (typeof window.SmileUI !== 'undefined') {
    onSmileUiLoaded();
  }
})();
